import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AccessService } from '../services/access.service';

/**
 * Route guard that allows access to members of the Galaxy-Admins or Galaxy-MVP0-Navigator
 * Entra ID groups. If the membership check hasn't resolved yet, triggers a backend check
 * before deciding. Non-members are redirected to the root.
 */
export const navigatorAccessGuard: CanActivateFn = () => {
  const accessService = inject(AccessService);
  const router = inject(Router);
  const messageService = inject(MessageService);

  const currentValue = accessService.hasNavigatorAccess();

  if (currentValue === true) return true;

  const galaxyAdmin = accessService.isGalaxyAdmin();
  const navigatorMvp0 = accessService.isNavigatorMvp0User();
  if (galaxyAdmin !== null && navigatorMvp0 !== null) {
    messageService.add({ severity: 'warn', summary: 'You do not have access to this page.', life: 6000 });
    return router.createUrlTree(['/']);
  }

  // null = not yet resolved — trigger a check and wait for the result
  return accessService.checkAccess().pipe(
    map(result => {
      if (result.galaxyAdmins === true || result.navigatorMvp0Users === true) return true;
      messageService.add({ severity: 'warn', summary: 'You do not have access to this page.', life: 6000 });
      return router.createUrlTree(['/']);
    })
  );
};
